import React from "react";
import LeagueRankRail from "./LeagueRankRail";
import useStickyRail from "../../../utils/useStickyRail";

// The two-column body a league screen sits in: one main column, one sticky rail.
//
// Client Rev 2, desktop inside a league: "Can Home's existing main column plus
// sticky right rail layout be reused as a shared shell for Portfolio and
// Watchlist with minimal work? One consistent main column width across Home,
// Portfolio, and Watchlist. Sticky right rail beside that column."
//
// It could, and this is it. League Home already had exactly this grid inline; it
// now lives here instead, so Home, Portfolio and Watchlist share ONE definition
// of the column width and the rail rather than three copies that drift the way
// the CREATED BY block did.
//
// `minmax(0,1fr)` on the main track (plus `min-w-0` on the column itself) is what
// stops a wide child — a portfolio table, the watchlist's asset rows — from
// forcing the track wider than its share and pushing the rail off screen; grid
// tracks are min-content sized by default.
//
// The rail is desktop-only. Below `lg` the grid collapses to one column and the
// rail is not rendered at all, so mobile Portfolio and Watchlist look exactly as
// they did — the client's note is a DESKTOP note.
//
// Trade is deliberately not on this shell: "Trade remains the purposeful full
// width exception."
//
// `className` carries the screen's own top margin, because they differ on
// purpose: Home has `mt-4` under its "League feed" heading block, while Portfolio
// and Watchlist use `mt-2` — the tighter gap client Rev 3 asked for ("the gap
// below it should be much tighter").
// `withRail={false}` is for the one screen that renders the rail HIGHER UP than
// this grid: a cash game's Home passes it to LeagueShell instead, so the prize
// card can start level with the identity header. Without the opt-out the rail
// would be drawn twice on that screen.
const LeagueColumns = ({ game, className = "mt-4", withRail = true, children }) => {
  // The rail's `lg:sticky` is inert without this — see useStickyRail, which is
  // now the one definition of the flag (the Cash Game landing page needs it too).
  useStickyRail();

  return (
  <div
    className={`${className} grid grid-cols-1 gap-6 items-start ${
      withRail ? "lg:grid-cols-[minmax(0,1fr)_320px]" : ""
    }`}
  >
    <div className="min-w-0">{children}</div>
    {withRail && (
      <aside className="hidden lg:block">
        <LeagueRankRail game={game} />
      </aside>
    )}
  </div>
  );
};

export default LeagueColumns;
